import TechCampCoursePage from "./techCampCoursePage"

export default TechCampCoursePage;